module.exports = __webpack_public_path__ + "static/img/n11-13.95fb29f.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/n11-13.png
// module id = Jli/
// module chunks = 2